<template>
  <div class="guest-layout">
    <header class="guest-header">
      <div class="container">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-4 logo-container">
            <div class="logo-wrapper">
              <img :src="$brand.logos.horizontal" alt="SecurCloud" class="logo-image" />
            </div>
          </div>
            <div class="brand-text">
              <h1 class="brand-title">SecurCloud</h1>
              <p class="brand-subtitle">{{ $t('guest_layout.subtitle') }}</p>
            </div>
        </div>
      </div>
    </header>

    <main class="guest-main">
      <slot></slot>
    </main>

    <footer class="guest-footer">
      <div class="container">
        <p class="text-sm text-gray-600 text-center">
          &copy; {{ new Date().getFullYear() }} SecurCloud. {{ $t('footer.all_rights_reserved') }}
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'GuestLayout'
};
</script>

<style scoped>
.guest-layout {
  max-width: 1600px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f5f5f5;
  margin: 0 auto;
  padding: 0;
}

.guest-header {
  position: relative;
  background: #ffffff;
  padding: 16px;
  overflow: hidden;
  border-bottom: 4px solid #3b82f6;
  margin: 0;
}

.guest-header .container {
  max-width: 1600px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}


.logo-image {
  height: 36px;
  width: auto;
  display: block;
}

.brand-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.brand-title {
  color:#000000;
  font-size: 18px;
  line-height: 1;
  margin: 0;
  padding: 0;
}

.brand-subtitle {
  color:#000000;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.5px;
  margin: 0;
  padding: 0;
}


.guest-main {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.guest-footer {
  background: white;
  border-top: 1px solid #e5e7eb;
  padding: 16px 0;
  margin-top: auto;
}

.guest-footer .container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 20px;
}

@media (max-width: 768px) {
  .brand-text {
    display: none;
  }
  
  .header-badge {
    font-size: 12px;
    padding: 8px 12px;
  }
  
  .logo-wrapper {
    padding: 6px 12px;
  }
  
  .logo-image {
    height: 24px;
  }
}
</style>
